export const VimLogo = ({ className = '', width = 18, height = 18, fill = 'black' }) => (
  <svg
    className={className}
    height={height}
    width={width}
    style={{ verticalAlign: 'middle' }}
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M575.146667 188.8v-20.352l23.168-24.533333h286.805333l19.626667 25.258666v63.146667L279.168 880.128H197.845333l-36.522666-20.309333V256h-21.034667l-20.992-20.309333V169.813333l22.442667-25.941333h283.392l22.314666 25.344 1.365334 2.048v62.464l-18.944 29.44h-23.168v196.394667L610.133333 263.125333h-11.178666l-23.893334-28.757333"
      fill={fill}
    />
  </svg>
);
